import React from 'react';

interface Props {
  title: string | null | undefined
  type?: 'xs' | 's' | 'm'
  whenEmpty?: string
}

const Abbreviation: React.VFC<Props> = (props: Props) => {

  const {
    title,
    whenEmpty = "-",
    type = 'm',
  } = props;


  return (

    <div className={`abbreviation-${type}`} title={title || whenEmpty}>
      {title || whenEmpty}
    </div>

  );

}


export default Abbreviation;
